import { Component, Input, OnInit, Inject, ViewEncapsulation, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { ArticleService } from '../../../core/services/article.service'
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from '../../../core/services/api.service'
import { PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { LayoutService } from '../../../core/services/layout.service'
import { shareLink } from 'src/app/core/helpers/share-link'
import { ArticleHtmlTransformer } from './html-parser'
import { NGXLogger } from 'ngx-logger'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-article',
    templateUrl: './article.component.html',
    styleUrls: ['./article.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ArticleComponent implements OnInit {
  content: any = {}
  author: any = {}
  breakpoints: any = {
    extraSmall: false,
    small: false,
    large: true,
    extraLarge: true,
  }
  articleIndex = -1
  showVideoModal = false
  // this need for static author's rating
  items = [1, 1, 1, 1, 1]
  markedStars = 4
  markedStarsArticle = 4
  equipmentProviderInActive: boolean =false

  htmlChanger: ArticleHtmlTransformer

  constructor(private articleService: ArticleService,
    private api: ApiService,
    private logger: NGXLogger,
    private activateRoute: ActivatedRoute,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private layoutService: LayoutService,
    public sharedDataService: SharedDataService
  ) {
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    // if(this.equipmentProviderInActive){
    //   document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
    // } else {
    //   document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
    // }
    this.htmlChanger = new ArticleHtmlTransformer()
  }

  ngOnInit() {
    this.articleSubscribe()
    this.layoutService
      .subscribeToLayoutChanges()
      .subscribe((observerResponse) => {
        this.breakpoints = this.layoutService.handleLayoutChanges()
      }, (error: any) => {
        console.error(error)
      })
    this.articleService.articleContent.subscribe(res => {
    }, (error: any) => {
      console.error(error)
    })
    // this.logger.info(this.content)
  }

  closeVideoModal() {
    this.logger.info('close')
    this.showVideoModal = false
  }

  videoOnClick() {
    // this.selectedVideo = video
    this.showVideoModal = true
    if (this.breakpoints.extraSmall) {
      // this.scrollToContainer()
    }
    else {
      // this.scrollToTop()
    }
      if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    setTimeout(() => {
      const e = document.querySelector('#videoModal')
      e.classList.add('fade-in')
    }, 0)

  }

  shareLink() {
    if (isPlatformBrowser(this.platformId)) {
      return shareLink('ICW Article', location.href)
    }
  }

  stripArticleHTML(html: string) {
    if (isPlatformBrowser(this.platformId)) {
      const article = document?.createElement('div')
      // tslint:disable-next-line
      article.innerHTML = html.trim()
      return article.querySelector('.article-content').innerHTML
    }
    else {
      return html
    }
  }

  getRelatedImage(content: any[]): string {
    const articleContents = content.map(v => {
      return [v.usage, v]
    })
    const o = Object.fromEntries(articleContents)
    return o['header-image'].url
  }
  getRelatedTitle(title: string) {
    return title.toLowerCase().replace(/[\.\,\!\?]/g, '').replace(/\s/g, '-')
  }

  articleSubscribe() {
    return this.articleService.articles.subscribe((res: any) => {
      const a = res.map(v => v.url)
      this.articleIndex = a.indexOf(this.activateRoute.snapshot.params.url)
      if (this.articleIndex !== -1) {
        this.content = res[this.articleIndex]
        this.api.getExternalHTML(this.content.body.url).toPromise().then(res2 => {
          // switch (this.articleIndex) {
          //   case 0:
          //     this.content.body = this.stripArticleHTML(this.body0)
          //     break
          //   case 1:
          //     this.content.body = this.stripArticleHTML(this.body1)
          //     break
          //   case 2:
          //     this.content.body = this.stripArticleHTML(this.body2)
          //     break
          //   case 3:
          //     this.content.body = this.stripArticleHTML(this.body3)
          //     break
          //   case 4:
          //     this.content.body = this.stripArticleHTML(this.body4)
          //     break
          //   case 5:
          //     this.content.body = this.stripArticleHTML(this.body5)
          //     break
          // }
          this.content.body = this.stripArticleHTML(res2)
        }).catch(err => { console.log(err) })
        this.api.getArticleAuthor(this.content.authorId).subscribe((res3: any) => {
          this.author = res3[0]
        }, (error: any) => {
          console.error(error)
        })
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0)
      }
      // this.logger.info(this.content)
    }, (error: any) => {
      console.error(error)
    })
  }

  closeArticle() {
    this.router.navigateByUrl('/credit-tools#articles')
  }

  articlesNavigate(index?: number) {
    const arr = this.articleService.articlesUrls
    if (index < 0 || index >= arr.length) {
      return
    }
    this.articlesTo(arr[index])
  }

  articlesTo(url: string) {
    this.router.navigate(['/article', url])
    setTimeout(() => {
      this.articleSubscribe()
    }, 10)
  }





}
